
import layerEvents				from "../utils/layerEvents";
import {
	Button,
	Col,
	Row,
	Dropdown,
	Form,
	Card,
	Modal,
	Alert,
}								from "react-bootstrap";
import { Link }					from "react-router-dom";
import Select					from "react-select";
import {
	PencilSimple,
	Lightning,
	Windmill,
	BatteryCharging,
	BatteryFull,
	Spiral,
	Ruler,
	Crosshair,
	X,
	Info,
	Eye,
	Trash,
	DotsThreeVertical,
	Wind,
	Calculator,
	Warning,
	CircleNotch,
	Plus,
	Bulldozer,
	ArrowsOutLineVertical,
	ArrowsOutLineHorizontal,
	CarProfile,
	Circle,
	CheckCircle,
	ArrowCounterClockwise
}								from "@phosphor-icons/react";
import DataTable				from 'react-data-table-component';
import atlasApi					from "../utils/atlasapi";
import {
	format_power, 
	formatWeight,
	formatCurrency
}								from "../utils/functions";
import EditNow					from "../components/EditNow";
import DoNowButton				from "../components/DoNowButton";
import ReactDOM					from "react-dom/client";
import roadMode					from "../utils/roadMode";
import TurfArea					from '@turf/area';
import TurfBuffer				from '@turf/buffer';
import TurfLength				from '@turf/length';
import {
	formatArea,
	formatDistance
}								from "../utils/functions";
import PowerRoadsPanel			from "../components/PowerRoadsPanel";
import LayerRoad				from "../classes/LayerRoad";
import LayerAutoroads			from "../classes/LayerAutoroads";
import drawTheme				from "../utils/drawUtilsTheme";
import Tool						from "../classes/Tool";
import {ToolRoad}				from "../classes/ToolRoad";
import Cookies					from 'universal-cookie';



class ToolAutoRoad extends ToolRoad	{

	tabIndex			= null;
	highlightedOnList	= [];
	
	turbineTypes		= [];
	turbineHeights		= [];
	modified			= false;
	contextMenu			= null;
	lastSelection		= null;
	
	success				= <CheckCircle weight="bold" size={24} />
	pending				= <Circle weight="bold" size={24} />

	showDialog			= false;
	dialogChecked		= false;

	showApplyDialog		= false;
	applyDialogChecked	= false;
	pendingApplyRow		= null;
	
	type				= 'autoroad'
	constructor(p) {
		super(p);
	}
	init(){
		Tool.prototype.init.call(this);
		
		this.turbines = this.tc.scenario.wtgs.length;
		this.entrygate = this.tc.scenario?.gates?.length ?? 0;
		this.substations = this.tc.scenario?.substations?.length ?? 0;
		this.getMapping();
		this.display();
	}
	exit(){
		if (this._syncTimeout) {
			clearTimeout(this._syncTimeout);
			this._syncTimeout = null;
		}
		this.removeAutoroadsLayer();
		if(this.parent.serviceBar.current)
			this.parent.serviceBar.current.clear(this.tabIndex);
		this.tabIndex = null;
	}
	
	display(){
		if(this.parent.serviceBar.current)
			this.tabIndex =	this.parent.serviceBar.current.inject(this.render(), this.tabIndex);
	}


	resetLayer = ()=>{
		this.tc.infoLayers.current.resetSystemLayer("roads");
		
	}
	
	
	
	update(){
		this.resetLayer();
	}
	generateRoads(){
		this.showDialog = true;
		this.dialogChecked = false;
		this.display();
	}
	confirmGenerateRoads(){
		this.showDialog = false;
		this.calculationStarted = true;
		this.display();
		atlasApi.triggerAutoroadsCalculation(this.tc.scenario.projectid, this.tc.scenario.scenario_id, "My Route Calculation").then(() => {
			this.syncRoutes();
		});
	}

	syncRoutes(interval = 7000) {
		if (this._syncTimeout) return;

		const attempt = async () => {
			try {
				const response = await atlasApi.syncAutoroadsRoutes(this.tc.scenario.projectid, this.tc.scenario.scenario_id);

				if (response.status === 201) {
					this._syncTimeout = null;
					this.getRoutes();
					return;
				}

				if (response.status === 404) {
					this._syncTimeout = setTimeout(attempt, interval);
					this.display();
					return;
				}

				// 502 or any other failure — stop polling
				this._syncTimeout = null;
				this.calculationStarted = false;
				this.display();
			} catch {
				this._syncTimeout = null;
				
				this.calculationStarted = false;
				this.display();
			}
		};

		attempt();
	}
	cancelDialog(){
		this.showDialog = false;
		this.display();
	}
	
	getMapping(){
		return atlasApi.getAutoroadsMapping(this.tc.scenario.projectid).then((res)=>{
			
			if(!res?.error)
				this.getCalculation().then(()=>{
					this.display();
				});
			
			this.mapping = res;
			this.display();
			return this.mapping;
		});
	}
	
	hasMapping(){
		return !!this.mapping && !!this.mapping.id;
	}
	hasCalculation(){
		return !!this.calculation && !!this.has_calculation;
	}
	getCalculation(){
		this.calculationStarted = true;
		return atlasApi.getAutoroadsCalculation(this.tc.scenario.projectid, this.tc.scenario.scenario_id).then((res)=>{

			this.calculation = res;
			
			if(res?.has_calculation){
				this.getRoutes().then((routes)=>{
					if(!routes?.length){
						
						this.syncRoutes();
					}
					
				})
			}
			else
				this.calculationStarted = false;
			return res;
		});
	}

	getRoutes(){
		return atlasApi.getAutoroadsRoutes(this.tc.scenario.projectid, this.tc.scenario.scenario_id).then((res)=>{
			this.routes = res;
			this.calculationStarted = false;
			this.display();
			return this.routes;
		});
	}
	
	handleSelectRoute = (row) => {
		if (this.selectedRoute?.id === row.id) {
			this.selectedRoute = null;
			this.removeAutoroadsLayer();
		} else {
			this.selectedRoute = row;
			this.drawAutoroads(row.geom);
		}
		this.display();
	}

	drawAutoroads(geometry) {
		this.removeAutoroadsLayer();
		const aux = (new LayerAutoroads(geometry)).json();
		const map = this.tc.map;
		map.addSource(LayerAutoroads.sourceId, aux.source);
		aux.layer.forEach(l => map.addLayer(l));
	}

	removeAutoroadsLayer() {
		if (this.tc.map.getLayer(LayerAutoroads.layerId))
			this.tc.map.removeLayer(LayerAutoroads.layerId);
		if (this.tc.map.getSource(LayerAutoroads.sourceId))
			this.tc.map.removeSource(LayerAutoroads.sourceId);
	}
	
	handleEdit(row){
		this.tc.exit();
		this.tc.roadModeForce();
		
		super.handleEdit(row);
		
	}
	
	getApplyCookie() {
		return (new Cookies(null, { path: '/' })).get('autoroad-apply-confirm');
	}

	setApplyCookie() {
		const expires = new Date();
		expires.setFullYear(expires.getFullYear() + 1);
		(new Cookies(null, { path: '/' })).set('autoroad-apply-confirm', '1', { expires });
	}

	requestApplyRoute = (row) => {
		if (this.getApplyCookie()) {
			this.applyRoute(row);
		} else {
			this.pendingApplyRow   = row;
			this.showApplyDialog   = true;
			this.applyDialogChecked = false;
			this.display();
		}
	}

	confirmApplyRoute = () => {
		if (this.applyDialogChecked) this.setApplyCookie();
		this.showApplyDialog = false;
		const row = this.pendingApplyRow;
		this.pendingApplyRow = null;
		this.display();
		this.applyRoute(row);
	}

	cancelApplyDialog = () => {
		this.showApplyDialog = false;
		this.pendingApplyRow = null;
		this.display();
	}

	applyRoute = async (row) => {
		const pId = this.tc.scenario.projectid;
		const sId = this.tc.scenario.scenario_id;

		const persistedIds = (this.tc.scenario.roads ?? [])
			.filter(r => r.roadid && !isNaN(r.roadid))
			.map(r => r.roadid);

		this.tc.scenario.roads = [];
		this.removeAutoroadsLayer();
		this.resetLayer();
		this.display();

		if (persistedIds.length && sId)
			await atlasApi.bulkDeleteRoads(pId, sId, persistedIds);

		if (!sId || !row.geom?.coordinates?.length) return;

		const tempRoads = row.geom.coordinates.map((coords, idx) => {
			const tempid = Math.floor(1000000 + Math.random() * 10000000);
			return {
				type:       'Feature',
				geometry:   { type: 'LineString', coordinates: coords },
				name:       row.name + " "+(idx+1),
				width:      LayerRoad.defaultWidth,
				color:      LayerRoad.defaultColor,
				properties: { tempid }
			};
		});
		const s = {...this.tc.scenario};
		s.roads = tempRoads;
		this.tc.setScenario(s);
		this.resetLayer();
		this.display();

		const payload = tempRoads.map(r => ({
			geometry: r.geometry,
			name:     r.name,
			width:    r.width,
			color:    r.color
		}));

		atlasApi.createRoad(pId, sId, payload).then((res) => {
			const results = Array.isArray(res) ? res : [res];
			results.forEach((created, i) => {
				if (created?.id && s.roads[i]) {
					s.roads[i].roadid = created.id;
					delete s.roads[i].properties.tempid;
				}
			});
			this.tc.setScenario(s);
			this.resetLayer();
			this.tc.refreshProperties();
		});
	}
	
	ExpandedRow({data, requestApplyRoute}){

		return (<div className="autoroads-expandedrow"><Button onClick={()=>{requestApplyRoute(data);}} variant="primary">Select road network</Button></div>);
	}

	render(){
		const {getters} = this.parent.draw.context;
		
		const hasMapping = this.hasMapping();
		const hasCalculation = this.hasCalculation();
		
		return (
			<>
			<div className={"project-autoroads "}>
				<div className="title">
					Auto road tool (InfraSpace)
					{/*<span onClick={(e)=>{this.parent.exit()}} 	className="btn btn-close alt float-end"><X size={16} /></span>*/}
				</div>
				<div className="scroll">
				
					{!!this?.mapping?.id && this?.calculation?.has_calculation === false &&
					<div className="content">
						<>
							To generate roads from InfraSpace, first place turbines, an entry gate, and a substation.

							<ul className="activity-group mt-5 mb-5">
								<li className="activity-item">
									<span className={"icon " + (this.turbines ? "success" : "")}>{this.turbines ? this.success : this.pending}</span>
									<h3>Turbines</h3>
									{
										this.turbines ? 
										(this.turbines+" turbines placed" ) : 
										(<>
											{"Place minimum one turbine to generate roads" }
											<br />
											<Button variant="primary" onClick={(e)=>{this.tc.turbineModeForce(e);}}>Switch to turbine tool</Button>
										</>)
									}
								</li>
								<li className="activity-item">
									<span className={"icon " + (this.entrygate ? "success" : "")}>{this.entrygate ? this.success : this.pending}</span>
									<h3>Entry gate</h3>
									{
										this.entrygate ? 
										(this.entrygate+" gates placed" ) : 
										(<>
											{"Add entry gate to project boundary." }
											<br />
											<Button variant="primary" onClick={(e)=>{this.tc.gateModeForce(e);}}>Switch to entry gate tool</Button>
										</>)
									}
									
								</li>
								<li className="activity-item">
									<span className={"icon " + (this.substations ? "success" : "")}>{this.substations ? this.success : this.pending}</span>
									<h3>Substations</h3>
									{
										this.substations ? 
										(this.substations+" substations placed" ) : 
										(<>
											{"Place at least one substation to generate roads." }
											<br />
											<Button variant="primary" onClick={(e)=>{this.tc.substationModeForce(e);}}>Switch to substation tool</Button>
										</>)
									}
									
								</li>
							</ul>

							{!!this.substations && !!this.entrygate && !!this.turbines  && 
							<div className="mt-4">
								<b>You’re all set! Generate a network of roads to your project 100% automatically using InfraSpace.</b>
								<br />
								{!!this.calculationStarted &&
									<div className="btn btn-land-actions aep-3 mt-3">
										Generating roads <CircleNotch className="spin text-info" size={16} />
										
									</div>
								}
								{!this.calculationStarted &&
									<Button variant="primary mt-3" onClick={(e)=>{this.generateRoads();}}>Generate roads</Button>
								}
								
							</div>
							}
						</>
					</div>
					}
					{!!this?.mapping?.error && !this.routes?.length && 
					<div className="content">
						<Alert variant="info" className="with-icon m-0 mt-2 mb-4">
							<div className="icon">
								<Warning className="icon" weight="bold" size={16} />
							</div>
							<div className="text">
								<b>Important:</b> Info: Auto roads are not available for this project. Please contact Espen for more information.
							</div>

						</Alert>
					</div>
					}


					{(!!this.routes?.length || (!!this._syncTimeout || this.calculationStarted)) && this?.calculation?.has_calculation === true &&
					<div className="content p-0">
				
						{this.listRoads()}
				
						<div className="separator">
							<span>Infraspace Routes</span>
							
							<div className="action" onClick={(e)=>{this.confirmGenerateRoads();}}><ArrowCounterClockwise size={20} /></div>
						</div>
						{(!!this._syncTimeout || this.calculationStarted) &&
							<div className="text-center p-3"><CircleNotch className="spin text-info" size={32} /></div>
						}
						{!this.calculationStarted &&
						<DataTable
							data={this.routes}
							columns={
								[
									{
										name:'Name',
										selector: (row,index) => {return row.name},
										format: (row,index) => row.name,
										sortable:true,
									},
									{
										name:'Length',
										selector: row => row.total_length,
										format: (row,index) => formatDistance(row.total_length),
										sortable:true,
										style: {
											textAlign:'center'
										}
									},
									{
										name:'Cost',
										selector: row => row.total_cost,
										format: (row,index) => formatCurrency(row.total_cost),
										sortable:true,
										style: {
											textAlign:'center'
										},
									},
									{
										name:'Co₂',
										selector: row => row.total_embodied_co2,
										format: (row,index) =>  formatWeight(row.total_embodied_co2),
										sortable:true,
										style: {
											textAlign:'center'
										},
									},
								]
							}
							customStyles={{
								headCells:{
									style: {
										minWidth:'0px !important',
										fontWeight:'bold'
									}
								},
								cells:{
									style: {
										boxSizing:'content-box',
									}
								},
								rows:{
									selectedHighlightStyle:{
										backgroundColor:'gray'
									}
								}
							}}
							onRowClicked={this.handleSelectRoute }
							selectableRowSelected={r=>this.isSelectedOnList(r)}
							expandableRowExpanded={(row) => (row.id === this?.selectedRoute?.id)}
							highlightOnHover
							selectableRowsHighlight
							pointerOnHover
							expandableRows
							expandableRowsComponent={this.ExpandedRow}
							expandableRowsHideExpander
							expandableRowsComponentProps={{ requestApplyRoute: this.requestApplyRoute }}
							expandOnRowClicked
							sortIcon={<i className="ri-expand-up-down-line" />}
							noDataComponent={()=>{return (<></>)}}
							conditionalRowStyles ={[
								{ when: r => r.id == this?.selectedRoute?.id, style: { backgroundColor: '#f5f5f5', borderBottom:"0px !important" } }
							]}
							className="toolAutoroad"
						/>
						}
					</div>

					}
					
				</div>
			</div>

			<Modal show={this.showApplyDialog} onHide={this.cancelApplyDialog} centered>
				<Modal.Header closeButton>
					<Modal.Title>Apply road network</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<p>This will <strong>delete all existing roads</strong> in this scenario and replace them with the roads from the selected InfraSpace route. This action cannot be undone.</p>
					<Form.Check
						type="checkbox"
						label="Don't show this warning again"
						checked={this.applyDialogChecked}
						onChange={(e) => { this.applyDialogChecked = e.target.checked; this.display(); }}
					/>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="outline-primary" onClick={this.cancelApplyDialog}>Cancel</Button>
					<Button variant="primary" onClick={this.confirmApplyRoute}>Continue</Button>
				</Modal.Footer>
			</Modal>

			<Modal show={this.showDialog} onHide={()=>{this.cancelDialog();}} centered>
				<Modal.Header closeButton>
					<Modal.Title>Generate roads</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<p>The process of generating roads automatically with InfraSpace may take several minutes to finish, so please refresh this page manually to check for updates.</p>
					<Form.Check
						type="switch"
						label="Ignore project boundary when generating roads"
						checked={this.dialogChecked}
						onChange={(e)=>{ this.dialogChecked = e.target.checked; this.display(); }}
					/>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="outline-primary" onClick={()=>{this.cancelDialog();}}>Cancel</Button>
					<Button variant="primary" onClick={()=>{this.confirmGenerateRoads();}}>Continue</Button>
				</Modal.Footer>
			</Modal>
			</>
		);
	
	}
}


export { ToolAutoRoad};